import { createSelector } from '@reduxjs/toolkit';
import { getTermsValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectRoomsCount = createSelector(selectJsonQuery, jsonQuery => getTermsValue('rooms_count')(jsonQuery));
